import axios from 'axios';
import { ApiError } from '@app/api/ApiError';
import { deleteExpiryDate, deletePermission, deleteToken, deleteUser, persistToken, readExpiryDate, readToken } from '@app/services/localStorage.service';
import { refreshToken } from './auth.api';
import { setExpiryDate } from '@app/store/slices/expiryDateSlice';
import { setPermission } from '@app/store/slices/permissionSlice';
import { setUser } from '@app/store/slices/userSlice';
import { getExpiryDateFromToken } from '@app/utils/utils';
import { notificationController } from '@app/controllers/notificationController';
import { getStoredUserIp } from '@app/utils/ipUtils';

export const commonHttpApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

function redirectToLogin() {
 const currentVariant = process.env.REACT_APP_UI_VARIANT || 'control';

  if (currentVariant === 'user') {
    window.location.href = '/auth/login-user';
  } else if (currentVariant === 'store') {
    window.location.href = '/auth/login-store';
  } else {
    // default to control
    window.location.href = '/auth/login';
  }
}

const minuteBeforeExpired = 300000; // 5 minutes;

const apiKey = process.env.REACT_APP_APPLICATION_API_KEY ? process.env.REACT_APP_APPLICATION_API_KEY : "";

commonHttpApi.interceptors.request.use(async (config) => {
  let accessToken = readToken();

  config.headers = { ...config.headers, 'x-api-key': apiKey };

  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  
  // Add client IP from stored localStorage
  const clientIp = getStoredUserIp();
  if (clientIp) {
    config.headers['x-client-ip'] = clientIp;
  }
  
  const getExpiryDate = Math.floor((readExpiryDate()?.getTime() ?? 0) / 1000)
  const expiryDate = getExpiryDate * 1000;

  // if (expiryDate && new Date().getTime() > expiryDate - minuteBeforeExpired && accessToken) {
  //   const result = await refreshToken();
  //   if (result) {
  //     const { userRole, createdOnUtc, updatedOnUtc, deletedOnUtc, ...user} = result.data.user;
  //     const { rolePermissions } = userRole;
  //     // const { createdOnUtc, updatedOnUtc, deletedOnUtc, ...userRole} = userRole;
  //     setUser(user);
  //     setPermission(rolePermissions);
  //     setExpiryDate(getExpiryDateFromToken(result.data.access_token) ?? 0);
  //     persistToken(result.data.access_token);

  //     config.headers['Authorization'] = `Bearer ${result.data.access_token}`;
  //   }

  // }

  return config;
});

commonHttpApi.interceptors.response.use(undefined, (error: any) => {
  if (error.response?.data.result) {

    if (error.response.data.result.code == '300011' || error.response.data.result.code == 'HTTP_ERROR' || error.response.data.result.code == '999999') {

      deleteToken();
      deleteUser();
      deletePermission();
      deleteExpiryDate();

      redirectToLogin();
    }
    throw new ApiError<ApiErrorData>(error.response.data.result.message, {
      message: error.response.data.result.message,
      code: error.response.data.result.code,
      success: error.response.data.success,
      status: error.response.status,
    });
  } else {
    if (error.response?.status === 401) {

      if (!error.response.data.result) {
        deleteToken();
        deleteUser();
        deletePermission();
        deleteExpiryDate();

        redirectToLogin();
      } else {
        window.location.href = '/InvalidPermission';
      }
    }
    else if (error.response) {

      // Handle other errors with a response but without `result`
      throw new ApiError<ApiErrorData>('An unexpected error occurred.', {
        message: error.response.data?.message || 'Unknown error.',
        code: `${error.response.status}`,
        success: false,
        status: error.response.status,
      });
    } else {

      // Handle network or unexpected errors without a response
      notificationController.error({ message: 'Network error occurred.' });
      throw new ApiError<ApiErrorData>('Network error occurred.', {
        message: 'Network error occurred.',
        code: 'NETWORK_ERROR',
        success: false,
        status: 0,
      });

    }
  }
});

export interface ApiErrorData {
  message: string;
  success: boolean;
  code: string;
  status: number;
}